import React from "react";
import { Box, Typography, IconButton, Grid } from "@mui/material";
import HealthImg from "./../../assets/images/health.png";
import FinanceImg from "./../../assets/images/finance.png";
import PersonalMattersImg from "./../../assets/images/personal-matters.png";
import RightArrow from "./../../assets/images/arrow-right-primary.png";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
const Areas = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box pt={8} px={8} pb={2}>
      <Box sx={{ textAlign: "center" }}>
        <Typography
          color={"color.dark1"}
          mt={3}
          fontSize={"2.28rem"}
          fontWeight="bold"
          fontFamily="WixMadefor Bold"
          className="area-heading"
        >
          {t("areas-h1")}
        </Typography>
        <Typography
          fontSize={"1.35rem"}
          mt={6}
          color={"color.dark1"}
          fontWeight="400"
          lineHeight={"1.48rem"}
          fontFamily="WixMadefor"
          className="area-para"
        >
          {t("areas-h2-sub-1")}
          <br></br>
          {t("areas-h2-sub-2")}
        </Typography>
        <Grid container mt={6} spacing={8} px={8}>
          <Grid item md={4} xs={12}>
            <Box
              display={"flex"}
              height={"100%"}
              flexDirection={"column"}
              alignItems={"center"}
              // justifyContent={"space-between"}
              fontFamily="WixMadefor"
            >
              <img src={HealthImg} width={"100%"} />
              <Typography className="area-pic-text" fontSize={"1.33rem"}> {t("health")}</Typography>
            </Box>
          </Grid>
          <Grid item md={4} xs={12}>
            <Box
              display={"flex"}
              height={"100%"}
              flexDirection={"column"}
              alignItems={"center"}
              fontFamily="WixMadefor"
              // justifyContent={"space-between"}
            >
              <img src={FinanceImg} width={"107%"} />
              <Typography className="area-pic-text" fontSize={"1.33rem"}> {t("finance")}</Typography>
            </Box>
          </Grid>
          <Grid item md={4} xs={12}>
            <Box
              display={"flex"}
              height={"100%"}
              flexDirection={"column"}
              alignItems={"center"}
              fontFamily="WixMadefor"
              // justifyContent={"start"}
            >
              <img src={PersonalMattersImg} width={"105%"} />
              <Typography className="area-pic-text" fontSize={"1.33rem"}>
                {t("personal-maters")}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Typography
          my={7}
          mt={10}
          fontSize={"1.42rem"}
          color="color.magentaMid2"
          fontFamily="WixMadefor"
        >
          <Typography variant="span" pr={2} className="area-para">
            {t("visit-faqs")}
          </Typography>

          <IconButton onClick={() => navigate("/faq")}>
            <img src={RightArrow} height={17} />
          </IconButton>
        </Typography>
      </Box>
    </Box>
  );
};

export default Areas;
